




























import { Component, Vue } from 'vue-property-decorator'

@Component
export default class AppModal extends Vue {
  protected showModal = false

  mounted () {
    this.$emit('open')
    this.showModal = true
  }

  destroyed () {
    this.$emit('close')
  }
}
